module.exports = __webpack_public_path__ + "img/about2.19a54a1f.png";